import { FC } from 'react'
import {
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/shared/ui/Alert/AlertDialog'
import { AlertDialog, AlertDialogProps } from '@radix-ui/react-alert-dialog'
import { useDeleteUnitAmenity } from '../lib/use-delete-unit-amenity'
import { Loader } from '@mantine/core'
import { useTranslation } from 'react-i18next'

type DeleteUnitAmenityAlertProps = {
  selectUnitAmenityId: number
  onCloseModal: () => void
}

export const DeleteUnitAmenityAlert: FC<DeleteUnitAmenityAlertProps & AlertDialogProps> = ({
  selectUnitAmenityId,
  onCloseModal,
  ...props
}) => {
  const { isLoadingDelete, handleDeleteUnitAmenity } = useDeleteUnitAmenity()
  const { t } = useTranslation(['anemity'])

  return (
    <AlertDialog {...props}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('amenity:confirmation.are_you_absolutely_sure')}</AlertDialogTitle>
          <AlertDialogDescription>
            {t('amenity:confirmation.action_cannot_be_undone')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isLoadingDelete}>
            {t('amenity:buttons.cancel')}
          </AlertDialogCancel>
          <AlertDialogAction
            disabled={isLoadingDelete}
            className='bg-red hover:bg-red/80'
            onClick={() => handleDeleteUnitAmenity(selectUnitAmenityId, onCloseModal)}
          >
            {isLoadingDelete ? <Loader color='white' size='xs' /> : t('amenity:buttons.delete')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
